import 'slick-carousel'
// import GOOGLEMAP from '../plugins/googlemap'
import GET_ARTICLES from '../plugins/getArticles'

export default function HOME() {
  // map script
  // const km = w.siteinfo.mapApiKeys
  // const env_map_key = (!km[host]) ? km['local'] : km[host]
  // w.addScript({src:`https://maps.googleapis.com/maps/api/js?v=3&key=${env_map_key}&callback=load.mapScript.resolve`})

  $(() => {
  
    // トップページカスタム
    $.topInit();
  
    // ブロック整形
    (function(__){ $.each(__, $.topBlockCustomizer) }({
      'topics':{
        button:{
          disp: true,
          text: 'VIEW ALL',
          attr: {
            class: 'button button-inverse c-btn-icon-right'
          }
        },
        title:{
          html: '<span>NEWS</span><small>新着情報</small>' // プレーンテキストで動的にする場合は false
        },
        itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
          $this
            .append( $title.append($new) )
            .append( $catetitle )
            .append( $date )
            .append( $catch )
            .append( $body );
          // $date.insertAfter( $catetitle );
        }
      },
      // 'works':{
      //   title:{
      //     html: '<span>WORKS</span><small>施工事例</small>' // プレーンテキストで動的にする場合は false
      //   },
      //   itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
      //     $this
      //       .append( $title.append($new) )
      //       .append( $catetitle )
      //       .append( $date )
      //       .append( $catch )
      //       .append( $body );
      //     // $date.insertAfter( $catetitle );
      //   }
      // },
    }));

    window.load['mainvisual'].done(() => {

      /*****
       * Slick実行
       */
      $('[data-plugin="slider"]').slick({
        autoplay:true,
        fade: true,
        dots: false,
        speed: 1200,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false
      })

      // スクロールボタンをクリックで画面の高さ分スクロール
      $('.p-mainvisual__scroll').on('click',()=>{
        const height = $(window).innerHeight()
        $('body,html').animate({scrollTop: height },'fast','easeInOutExpo')
        return false
      })

      if($.UA.is_mobile){
        $.getFreeBlock({id:2}).then(
          function(res) {
            console.log(res);
            $(res).insertAfter('.p-mainvisual').addClass('conceptelement');
          }
        );
      }

    })

    window.load['block-case'].done(()=>{
      GET_ARTICLES('.p-block-case [data-plugin="getArticles"]')
    })

    window.load['block-news'].done(()=> {
      GET_ARTICLES('.p-block-news__list[data-plugin="getArticles"]',{
        makeItem(item){
          return $(`
          <a href="${item.href}" class="p-block-news__item">
            <span class="date">${item.date}</span>
            <span class="category">【${item.category.name}】</span>
            <h5 class="title">${item.title}</h5>
          </a>`)[0]
        }
      })
    })

    window.load['block-smilehome'].done(()=>{
      // GET_RSSFEED('.p-block-smilehome [data-plugin="getRssFeed"]')
      const $feedContainer = $('[data-plugin="getRssFeed"')
      const addItem = item => {
        const $date = new Date( item.pubDate );
        var toDoubleDigits = function(num) {
          num += "";
          if (num.length === 1) {
            num = "0" + num;
          }
         return num;
        };
        var year = $date.getFullYear();
        var month = toDoubleDigits($date.getMonth() + 1);
        var day = toDoubleDigits($date.getDate());
        const date = ( year + '.' + month + '.' + day );
        const $item = $(`
        <a href="${item.link}" target="_blank" class="p-block-smilehome__item">
        <p class="p-block-smilehome__item-date">${date}</p>
        <h4 class="p-block-smilehome__item-title">${item.title}</h4>
        </a>
        `)
        $feedContainer.append( $item )
      }
      $.getJSON('/asset/api/getRssFeed/',{
        url: 'http%3A%2F%2Fwww.smile-homes.jp%2Fnews%2F%3Ffeed%3Drss2',
        post_per_page: 4
      }).done( data => {
        $feedContainer.empty()
        data.forEach( item => addItem(item) );
      })
    })

  
  });


  // map
  // document.addEventListener( 'DOMContentLoaded', () => {
  //   $.when(
  //     w.load['mapScript'],
  //     w.load['contentFooter']
  //   ).done( () => GOOGLEMAP() )
  // } )
}